export function updateQuery(key: string, value: string) {
  if (window.history.pushState) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    const newPath = `${window.location.pathname}?${searchParams}`;
    window.history.pushState(null, "", newPath);
  }
}
